<template>
  <div
    :class="{
      'h-full': showSuccess,
    }"
  >
    <div v-if="!showSuccess" class="overseas-contact">
      <div class="text-[20px] text-center">
        Contact Enterprise Sales at Rendora
      </div>
      <a-divider />
      <SubmitForm :params="data?.data" @submit="onSubmit" />
    </div>
    <div v-else class="flex flex-col items-center justify-center h-full">
      <iconpark-icon name="pay-succ" size="52"></iconpark-icon>
      <div class="text-font-80 text-[20px] text-center mt-[16px]">
        Submit successfully
      </div>
      <div class="text-font-80 text-14 text-center mt-[12px]">
        Thank you for your support
      </div>
      <a-button type="primary" class="mt-[30px] w-[90px]" @click="onClose">
        Close
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SubmitForm from './components/form.vue'
import { getEnContactInfo, addEnContact } from '~/api/index'
import { type ContactEnAddRequest } from '~/api/interface/contact'

const showSuccess = ref(false)

const { data } = useAsyncData(getEnContactInfo)

const onSubmit = async (values: ContactEnAddRequest) => {
  await addEnContact(values)
  showSuccess.value = true
}

const onClose = () => {
  window.close()
}
</script>

<style lang="scss" scoped>
.overseas-contact {
  @apply bg-back-1 p-[30px_89px] mx-[20%] mb-[66px] rounded-[18px] mt-[30px] min-w-[1200px];
}
</style>
